module.exports = __webpack_public_path__ + "media/images/payments/ukash-dark-1fe7fa39318bc5175bca9e02f62774f0.svg";